import React, { useState } from "react";
import { Button, Typography, Box, Modal } from "@mui/material";
import WhatsAppApiModal from "./WhatsAppApiModal.tsx";

const SignupForm: React.FC = () => {
  // Modal visibility state, initially set to true to open the modal by default
  const [showWhatsAppModal, setShowWhatsAppModal] = useState(true);

  // Function to open the modal
  const openWhatsAppModal = () => setShowWhatsAppModal(true);

  // Function to close the modal
  const closeWhatsAppModal = () => setShowWhatsAppModal(false);

  return (
    <Box sx={{ padding: 3 }}> {/* Material-UI Box for consistent spacing */}
      <Typography variant="h4" gutterBottom>
        Apply for WhatsApp Business API
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={openWhatsAppModal}
        sx={{ marginTop: 2 }}
      >
        Apply for WhatsApp Business API
      </Button>

      <Modal open={showWhatsAppModal} onClose={closeWhatsAppModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          {/* Custom WhatsApp API modal content */}
          <WhatsAppApiModal onClose={closeWhatsAppModal} />
        </Box>
      </Modal>
    </Box>
  );
};

export default SignupForm;
